/* eslint-disable @typescript-eslint/no-explicit-any */

//
// Transform properties from the server into our preferred format:
//  - convert dates to Date objects (based on key naming convention)
//  - warn on snake case keys in dev
//

export function transformProps(props: any) {
  if (isDevelopment()) {
    warnOnSnakeCase(props);
  }

  return deepConvertDates(props);
}

//
// Helper functions
//

// Find JSON date strings in object, convert to Dates
function deepConvertDates(object: any) {
  if (Array.isArray(object)) {
    return object.map((item): any => deepConvertDates(item));
  }

  if (isPlainObject(object)) {
    return mapValues(object, (value, key): any => {
      if (isDateKey(String(key))) {
        if (isString(value)) {
          return new Date(value);
        }
      }
      return deepConvertDates(value);
    });
  }

  return object;
}

function warnOnSnakeCase(object: any): void {
  if (Array.isArray(object)) {
    object.forEach((item) => warnOnSnakeCase(item));
    return;
  }

  if (isPlainObject(object)) {
    for (const key in object) {
      if (key.match(/_/)) {
        console.warn(`Warning: snake case key "${key}". Please use camel case.`);
      }
    }
  }
}

function isDateKey(key: string) {
  return key.match(/[a-z]At$/) || key.match(/^(date)/);
}

function isDevelopment() {
  return import.meta.env.MODE === "development";
}
